import { useSelector } from "react-redux";
import ProductTiles from "../../../presentational/customerItems/ProductTiles";
import {
  getSavedItems,
  getUserIsAuthenticated
} from "../../../../state/selectors";

const ProductTilesContainer = props => {
  const savedItems = useSelector(getSavedItems);
  const isAuthenticated = useSelector(getUserIsAuthenticated);

  return <ProductTiles {...{ ...props, savedItems, isAuthenticated }} />;
};

export default ProductTilesContainer;
